const NBA_TEAM_PRIMARY_COLORS_BY_NAME: Record<string, string> = {
  'atlanta hawks': '#E03A3E',
  'boston celtics': '#007A33',
  'brooklyn nets': '#000000',
  'charlotte hornets': '#1D1160',
  'chicago bulls': '#CE1141',
  'cleveland cavaliers': '#860038',
  'dallas mavericks': '#00538C',
  'denver nuggets': '#0E2240',
  'detroit pistons': '#C8102E',
  'golden state warriors': '#1D428A',
  'houston rockets': '#CE1141',
  'indiana pacers': '#002D62',
  'los angeles clippers': '#C8102E',
  'los angeles lakers': '#552583',
  'memphis grizzlies': '#5D76A9',
  'miami heat': '#98002E',
  'milwaukee bucks': '#00471B',
  'minnesota timberwolves': '#0C2340',
  'new orleans pelicans': '#0C2340',
  'new york knicks': '#006BB6',
  'oklahoma city thunder': '#007AC1',
  'orlando magic': '#0077C0',
  'philadelphia 76ers': '#006BB6',
  'phoenix suns': '#1D1160',
  'portland trail blazers': '#E03A3E',
  'sacramento kings': '#5A2D81',
  'san antonio spurs': '#C4CED4',
  'toronto raptors': '#CE1141',
  'utah jazz': '#002B5C',
  'washington wizards': '#002B5C',
};

const NBA_TEAM_PRIMARY_COLORS_BY_ABBREVIATION: Record<string, string> = {
  ATL: '#E03A3E',
  BOS: '#007A33',
  BKN: '#000000',
  CHA: '#1D1160',
  CHI: '#CE1141',
  CLE: '#860038',
  DAL: '#00538C',
  DEN: '#0E2240',
  DET: '#C8102E',
  GSW: '#1D428A',
  HOU: '#CE1141',
  IND: '#002D62',
  LAC: '#C8102E',
  LAL: '#552583',
  MEM: '#5D76A9',
  MIA: '#98002E',
  MIL: '#00471B',
  MIN: '#0C2340',
  NOP: '#0C2340',
  NYK: '#006BB6',
  OKC: '#007AC1',
  ORL: '#0077C0',
  PHI: '#006BB6',
  PHX: '#1D1160',
  POR: '#E03A3E',
  SAC: '#5A2D81',
  SAS: '#C4CED4',
  TOR: '#CE1141',
  UTA: '#002B5C',
  WAS: '#002B5C',
};

const NBA_TEAM_NAME_ALIASES: Record<string, string> = {
  'la clippers': 'los angeles clippers',
  'la lakers': 'los angeles lakers',
};

function normalizeTeamName(teamName?: string | null): string {
  return (teamName ?? '').trim().toLowerCase().replace(/\s+/g, ' ');
}

function normalizeSport(sport?: string | null): string {
  return (sport ?? '').trim().toUpperCase();
}

export interface TeamPrimaryColorParams {
  sport?: string | null;
  teamName?: string | null;
  teamAbbreviation?: string | null;
}

export function getTeamPrimaryColor({
  sport,
  teamName,
  teamAbbreviation,
}: TeamPrimaryColorParams): string | undefined {
  if (normalizeSport(sport) !== 'NBA') {
    return undefined;
  }

  const normalizedName = normalizeTeamName(teamName);
  const canonicalName = NBA_TEAM_NAME_ALIASES[normalizedName] ?? normalizedName;
  if (canonicalName) {
    const color = NBA_TEAM_PRIMARY_COLORS_BY_NAME[canonicalName];
    if (color) {
      return color;
    }
  }

  const normalizedAbbreviation = (teamAbbreviation ?? '').trim().toUpperCase();
  if (!normalizedAbbreviation) {
    return undefined;
  }

  return NBA_TEAM_PRIMARY_COLORS_BY_ABBREVIATION[normalizedAbbreviation];
}
